import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { Error404Component } from 'app/modules/admin/pages/error/error-404/error-404.component';


// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'landing-home'}, // en redirect antes estaba example

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'landing-home'}, // en redirect antes estaba example

    // Auth routes for guests
    {
        path: '',
        canMatch: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/authentication/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/authentication/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'reset-password', loadChildren: () => import('app/modules/authentication/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('app/modules/authentication/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('app/modules/authentication/sign-up/sign-up.module').then(m => m.AuthSignUpModule)},
            {path: 'activate-account', loadChildren: () => import('app/modules/authentication/activate/activate.module').then(m => m.ActivateModule)},
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/authentication/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'unlock-session', loadChildren: () => import('app/modules/authentication/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)},
            {path: 'profile', loadChildren: () => import('app/modules/admin/pages/profile/profile.module').then(m => m.ProfileModule)},
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
        ]
    },

    // Admin routes
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            //{path: 'example', loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule)},
            {path: 'landing-home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
            // Settings
            {path: 'settings', loadChildren: () => import('app/modules/admin/pages/settings/settings.module').then(m => m.SettingsModule)},
            // Users
            {path: 'users', loadChildren: () => import('app/modules/users/users.module').then(m => m.UsersModule)},
            // Hotel Sales
            {path: 'hotel-sales', loadChildren: () => import('app/modules/hotel-sales/hotel-sales.module').then(m => m.HotelSalesModule)},
            // Vehicles
            {path: 'vehicles', loadChildren: () => import('app/modules/vehicle/vehicle.module').then(m => m.VehicleModule)},
            // Contacts
            {path: 'persons', loadChildren: () => import('app/modules/persons/persons.module').then(m => m.PersonsModule)},
            // Person Groups
            {path: 'person-groups', loadChildren: () => import('app/modules/person-groups/person-groups.module').then(m => m.PersonGroupsModule)},
            // Products
            {path: 'products', loadChildren: () => import('app/modules/products/products.module').then(m => m.ProductsModule)},
            // Tasks
            {path: 'tasks', loadChildren: () => import('app/modules/tasks/tasks.module').then(m => m.TasksModule)},
            // Sectors
            {path: 'sectors', loadChildren: () => import('app/modules/sectors/sectors.module').then(m => m.SectorsModule)},
            //PointOfSaleModules
            {path: 'pointOfSaleMovements', loadChildren: () => import('app/modules/pointOfSaleMovements/pointOfSaleMovements.module').then(m => m.PointofsalemovementsModule)},
            //Sales
            {path: 'sales', loadChildren: () => import('app/modules/sales/sales.module').then(m => m.SalesModule)},
            {path: 'payments', loadChildren: () => import('app/modules/sales/sales.module').then(m => m.SalesModule)},

        ]
    },
    { path: '404', component: Error404Component },
    { path: '**', redirectTo: '/404' },
]
